// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#bfcbd9","menuActiveText":"#409EFF","subMenuActiveText":"#f4f4f5","menuBg":"#fff","menuHover":"#263445","subMenuBg":"#1f2d3d","subMenuHover":"#001528","sideBarWidth":"256px"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/mobile.scss
// module id = WeTo
// module chunks = 51